"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const contact_details_1 = __importDefault(require("./contact-details"));
require("./styles.scss");
const LocationContact = ({ locationName, phone, tollFree, tty, fax, email, website, employmentOntarioLiveChatLink, showPhoneLabels }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("h2", Object.assign({ className: "ontario-h3" }, { children: t("locationNameAddress.title") })), (0, jsx_runtime_1.jsx)(contact_details_1.default, { locationName: locationName, phone: phone, tollFree: tollFree, tty: tty, fax: fax, email: email, website: website, employmentOntarioLiveChatLink: employmentOntarioLiveChatLink, showPhoneLabels: showPhoneLabels })] }));
};
exports.default = LocationContact;
